import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-4" data-testid="eyebrow">
    <span className="h-px w-10 bg-bronze" />
    <span className={`font-heading text-[13px] font-bold uppercase tracking-[0.24em] ${dark ? "text-bronze" : "text-bronze"}`}>
      {children}
    </span>
  </div>
);
